import { axiosPost } from "./ajaxServices";
import {
  urlCreateShopCategory,
  urlUpdateShopCategory,
  urlGetShopCategoryList,
  urlGetAllShopCategories,
  urlDeleteShopCategory,
  urlUpdateShopCategoryPosition,
} from "./CONSTANTS";

export function apiCreateShopCategory(data) {
  const url = urlCreateShopCategory;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("name", data.name);
  formData.append("status", data.status);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiUpdateShopCategory(data) {
  const url = urlUpdateShopCategory;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", data.id);
  formData.append("name", data.name);
  formData.append("status", data.status);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const apiGetShopCategoryList = (currentPage, pageSize, startDate, endDate) => {
  const url = urlGetShopCategoryList;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiGetAllShopCategories = () => {
  const url = urlGetAllShopCategories;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export function apiUpdateShopCategoryPosition(dataList) {
  const url = urlUpdateShopCategoryPosition;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var idList = [];
  for (let i = 0; i < dataList.length; i++) {
    idList.push({ id: dataList[i]["id"] });
  }
  var formData = new FormData();
  formData.append("dataList", JSON.stringify(idList));
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export function apiDeleteShopCategory(id) {
  const url = urlDeleteShopCategory;
  const config = { headers: { "content-type": "multipart/form-data" } };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
